










































































import Vue from 'vue';

import BaseCell from '@/components/Table/BaseCell.vue';
import ModalControlsPanel from '@/components/Form/ModalControlsPanel.vue';
import { BTable } from 'bootstrap-vue';

export default Vue.extend({
    name: 'GridInput',
    components: {
        BaseCell,
        ModalControlsPanel,
    },
    props: {
        /** Значение ввода */
        modelValue: {
            type: Array,
            required: true,
        },
        /** Описание полей таблицы */
        fields: {
            type: Array,
            required: true,
            default: function() {
                return [];
            }
        },
        /** Префикс для синтеза уникальных id */
        idPrefix: {
            type: String,
            required: true,
        },
        /** Первичный ключ сущнотей отображаемых в таблицы */
        primaryKey: {
            type: String,
            required: true,
        },
        /** Набор данных (полный) */
        dataSet: {
            type: Array,
            required: false,
        },
    },
    model: {
        prop: 'modelValue',
        event: 'input',
    },
    computed: {
        inputId(): string {
            return this.idPrefix + '-input';
        },
        addableSet(): Array<any> {
            const chooseDataSet = new Array<any>();
            this.dataSet.forEach(item => {
                const overlap = this.modelValue.filter(
                    modelItem =>
                        (modelItem as any)[this.primaryKey] === (item as any)[this.primaryKey]
                );
                if (overlap.length === 0) {
                    chooseDataSet.push(item);
                }
            });
            return chooseDataSet;
        },
    },
    methods: {
        addDialog() {
            this.addShow = true;
        },
        onRowSelected(items: Array<any>) {
            if (items !== undefined && items.length > 0) {
                this.selected = items[0];
            } else {
                this.selected = undefined;
            }
        },
        onAddRowSelected(items: Array<any>) {
            if (items !== undefined && items.length > 0) {
                this.addSelected = items[0];
            } else {
                this.addSelected = undefined;
            }
        },
        onAddRowDblClick(object: any, index: number): void {
            (this.$refs.addModalTable as BTable).clearSelected();
            (this.$refs.addModalTable as BTable).selectRow(index);
            this.addSelected = object;
            this.addAction();
        },
        closeAdd() {
            this.addSelected = undefined;
            const addTable = this.$refs.addModalTable as BTable;
            if (addTable !== undefined) addTable.clearSelected();
            this.addShow = false;
        },
        addAction() {
            if (this.addSelected !== undefined) {
                this.modelValue.push(this.addSelected);
                this.$emit('input', this.modelValue);
                this.closeAdd();
            }
        },
        deleteEvent() {
            const dataArray = this.modelValue as Array<any>;
            const index = dataArray.findIndex(
                x => x[this.primaryKey] === this.selected[this.primaryKey]
            );
            this.modelValue.splice(index, 1);
            this.$emit('input', this.modelValue);
        },
    },
    data() {
        return {
            tableRows: [],
            selected: undefined as any | undefined,
            addShow: false,
            addSelected: undefined as any | undefined, 
        };
    },
});
